import { render, staticRenderFns } from "./ShipmentRuleEditor.vue?vue&type=template&id=91d0810e"
import script from "./ShipmentRuleEditor.vue?vue&type=script&lang=js"
export * from "./ShipmentRuleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports